import { api } from 'shared/api'

import { TemplateApiSchemas } from './schema'

export const BotTemplateApi = {
  getBotTemplate: api.base.createGet({
    url: '/template/{template_hash}/getData',
    schemas: TemplateApiSchemas.getData,
  }),
  installTemplate: api.base.createPost({
    url: '/template/{template_hash}/process',
    schemas: TemplateApiSchemas.install,
  }),
}
